import { useFormik } from 'formik';
import * as Yup from 'yup';

interface UseRefundFormikProps {
  onSubmit: (values: any) => void;
}

export const refundManageGestorValidatorSchema = Yup.object({
   reason: Yup.string()
    .nullable()
    .max(500, 'La razón no debe superar los 500 caracteres'),
 
});
export const useRefundManageValidatorGestor = ({
  onSubmit,
}: UseRefundFormikProps) => {
  return useFormik({
    initialValues: {
      reason: '',
    },
    validationSchema: refundManageGestorValidatorSchema,
    onSubmit,
  });
};

export const refundManageGestorValidatorItemsSchema = Yup.object({
  id: Yup.string().required('ID requerido'),
  status_id: Yup.string().required('Estado requerido'),
  observationsItem: Yup.string().required('Observaciones requeridas'),
 
});
export const useRefundManageValidatorGestorItems = ({
  onSubmit,
}: UseRefundFormikProps) => {
  return useFormik({
    initialValues: {
      id: '',
      status_id: '',
      observationsItem: ''
    },
    validationSchema: refundManageGestorValidatorItemsSchema,
    onSubmit,
  });
};